/**
 * Created by Victor Rojo on 31/8/17.
 */
import { Component, OnInit, OnDestroy }        from '@angular/core';
import { Router, NavigationEnd }                   from '@angular/router';
import { AuthService }              from './shared/auth/auth.service';
import { CloudAccountService }      from "./profile/cloudAccount.service";

import {NotificationService} from "./notification/notification.service";
import {PreviousRouteService} from "./shared/auth/PreviousRoute.service";
import {Globals} from "./globals";



@Component({
  selector: 'cnxn-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainComponent implements OnInit, OnDestroy{

  public toastOptions = {
    position: ["top", "right"],
    timeOut: 3000,
    theClass: "bg-teal",
    lastOnBottom: true,
    showProgressBar: true,
    pauseOnHover: false,
  };
  userName:string;
  isAdmin = false;
  accountName:string;
  unreadNotifications: any;
  private subscription: any;


  constructor(
    private authService: AuthService,
    private accountService: CloudAccountService,
    private notificationService: NotificationService,
    private previousRouteService: PreviousRouteService,
    private router: Router,
    private globals: Globals) {

    let lastUnreadCount = this.notificationService.getLastUnreadCount();
    if (lastUnreadCount) {
      this.updateUnreadCount(lastUnreadCount);
    }

    this.setTenant();

    this.subscription = this.notificationService.unreadChange$.subscribe( (records:any[]) => this.updateUnreadCount(records));

    this.notificationService.startPolling();
  }

  ngOnInit():void {
    this.userName = this.authService.getUserName();
    let roles = this.authService.getUserRoles();
    let cloudDashboard = this.authService.getCloudDahsboard();

    let previousUrl = this.previousRouteService.getPreviousUrl();

    if ( previousUrl == "/" || previousUrl == "/login") {
      if ( cloudDashboard ) {
        this.router.navigate(['cloud'], {replaceUrl:true});
      } else if ( this.router.url == "/" ) {
        this.router.navigate(['dashboard']);
      }
    } else {
      if ( this.router.url == "/" ) {
        this.router.navigate(['dashboard']);
      }
    }

    this.isAdmin = roles.reduce( (carry, value) => carry || value == "ROLE_END_USER_ADMIN", false);
    let account_id = this.authService.getAccountID();
    this.accountService.get(account_id)
      .then( account => {
        this.accountName = account.company || account.accountName;
      });
  }

  private setTenant(){
    let tenant = "";
    let customization = this.authService.getVertical();
    if ( customization ) {
      customization.split(" ")
        .forEach(klass => {
          if ( klass == "galp" || klass == "ask" || klass == "ecomanager" || klass == "hiotera" || klass == "nacexa"
              || klass == "geo4radon" || klass == "ecuador" || klass == "q8"  || klass == "demoipetrol" || klass == "freeenergia"
              || klass == "kontrolwat" || klass == "respira" || klass == "iotino" || klass == "depourense" || klass == "h2h"
              || klass == "hacsuite" || klass == "smartpadel") {
            tenant = klass;
          }
        });
    }
    if (tenant == ""){
      tenant = 'smartpadel';
    }
    this.globals.tenant = tenant;
  }

  private updateUnreadCount(records:any[]){
    let count = records
      .map((record: any) => record.unread)
      .reduce((a:number, b:number) => a + b, 0);
    this.unreadNotifications = count > 99 ? "+99" : count;
  }

  logout(): void {
    this.authService.logout(false);
  }

  public ngOnDestroy(): void {
    if ( this.subscription ) {
      this.subscription.unsubscribe();
    }
    this.notificationService.resetLastNotificationTimestamp();
    this.notificationService.stopPolling();
  }
}
